// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","grayDark":"undefined","blackLight":"undefined","root":"WhatsNew-module--root--1fUgG"};